import { db } from './firebase';
import { doc, orderBy, query, Timestamp, updateDoc, where, writeBatch } from 'firebase/firestore';
import { collection, getDocs } from "firebase/firestore";


export const fetchMembersByQuery = async (type, setData) => {
    try {
        const q = query(collection(db, "members"), where("type", "==", type), orderBy("index", 'asc'));
        const querySnapshot = await getDocs(q);
        let members = []
        querySnapshot.forEach((doc) => {
            members = [...members, doc.data()]
            //console.log(doc.id, " => ", doc.data());
        });
        setData(members)
    }
    catch (e) {
        console.error("Firebase Error: ", e);
    }
}

export const fetchMemberByQuery = async (firstName, lastName, setData) => {
    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    try {
        firstName = capitalize(firstName)
        lastName = capitalize(lastName)
        const q = query(collection(db, "members"), where("firstname", "==", firstName), where("lastname", "==", lastName));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            const doc = querySnapshot.docs[0];
            setData(doc.data())
        }
    }
    catch (e) {
        console.error("Firebase Error: ", e);
    }
}

export const fetchMemberByEmail = async (email, setData) => {
    try {
        const q = query(collection(db, "members"), where("email", "array-contains", email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const doc = querySnapshot.docs[0];
            setData(({...doc.data(), id: doc.id}))
            
        }

    } catch (error) {
        console.error("Error fetching member by email:", error);
        throw error;
    }
};

export const updateMemberDetail = async ({ id, ownlanguage, description, fields, education, professionalServices, awards, email, links, publications }) => {
    if (!id) throw new Error("Document ID is required for updating news.");

    try {
        const updateData = {
            ownlanguage,
            description,
            fields,
            education,
            professionalServices,
            awards,
            email,
            links,
            publications,
            timestamp: Timestamp.now()
        };

        const docRef = doc(db, "members", id);
        await updateDoc(docRef, updateData);

        console.log(`News document with ID ${id} updated successfully.`);
    } catch (error) {
        console.error("Error updating news document:", error);
        throw error;
    }
};

export const manuallyModifyMembers = async (fieldsToEnsure = []) => {
    try {
        const querySnapshot = await getDocs(collection(db, "members"));
        for (const documentSnap of querySnapshot.docs) {
            const docData = documentSnap.data();
            const missingFields = {};

            fieldsToEnsure.forEach(({ field, init }) => {
                if (!(field in docData)) {
                    missingFields[field] = init;
                }
            });

            if (Object.keys(missingFields).length > 0) {
                const docRef = doc(db, "members", documentSnap.id);
                await updateDoc(docRef, missingFields);
                console.log(`Updated ${documentSnap.id}:`, missingFields);
            }
        }

        console.log("✅ Field checks completed for all members.");
    } catch (error) {
        console.error("❌ Error updating members:", error);
    }
};

export async function backupCollection() {
  const sourceCol = collection(db, "members");
  const backupCol = collection(db, "members_backup");

  try {
    // 1. Get all documents from source
    const snapshot = await getDocs(sourceCol);
    
    if (snapshot.empty) {
      console.log("No documents to copy.");
      return;
    }

    // 2. Create a batch
    const batch = writeBatch(db);

    // 3. Loop through docs and prepare the copy
    snapshot.docs.forEach((originalDoc) => {
      const data = originalDoc.data();
      
      // Reference to the new location (keeping the same ID)
      const newDocRef = doc(backupCol, originalDoc.id); 
      
      // Add the "set" operation to the batch
      batch.set(newDocRef, data);
    });

    // 4. Commit the batch (All writes happen at once)
    await batch.commit();
    console.log(`Successfully backed up ${snapshot.size} documents!`);

  } catch (error) {
    console.error("Error backing up collection:", error);
  }
}



export async function regenerateAllIDs(collectionName) {
  const colRef = collection(db, collectionName);
  
  try {
    // 1. Get all current documents
    const snapshot = await getDocs(colRef);

    if (snapshot.empty) {
      console.log("No documents found.");
      return;
    }

    console.log(`Found ${snapshot.size} documents. Starting regeneration...`);

    // 2. Create a Batch (Allows up to 500 operations)
    const batch = writeBatch(db);

    snapshot.docs.forEach((originalDoc) => {
      const data = originalDoc.data();
      
      // Step A: Create a reference with a NEW Auto-Generated ID
      // (Calling doc() without a 2nd argument automatically generates an ID)
      const newDocRef = doc(colRef); 
      
      // Step B: Queue the "Copy" operation
      batch.set(newDocRef, data);

      // Step C: Queue the "Delete" operation for the old ID
      batch.delete(originalDoc.ref);
    });

    // 3. Commit the batch (Executes all copies and deletes instantly)
    await batch.commit();
    console.log("Success! All Document IDs have been regenerated.");

  } catch (error) {
    console.error("Error regenerating IDs:", error);
  }
}